export default __webpack_public_path__ + "static/media/23.72d07752.JPG";